// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"91":"components-pages-HomePage","936":"components-pages-tracuuhienvat-ThongTinChiTiet"}[chunkId] + "." + {"91":"7c83fc5b","936":"c8640548"}[chunkId] + ".chunk.css";
};